import { CompositeScreenProps } from '@react-navigation/native'
import { createStackNavigator, StackScreenProps } from '@react-navigation/stack'
import React from 'react'
import { useTranslation } from 'react-i18next'

import HeaderLogo from '../../components/HeaderLogo/HeaderLogo'
import { useScreenOptions } from '../../hooks/use-screen-options'
import { Support as SupportScreen } from '../../screens/Support'
import styles from '../styles'

import { MainTabParamList, MainTabScreenProps } from '.'

export type SupportStackParamList = {
  Support: undefined
}

export type SupportStackScreenProps<T extends keyof SupportStackParamList> = CompositeScreenProps<
  StackScreenProps<SupportStackParamList, T>,
  MainTabScreenProps<keyof MainTabParamList>
>

export const supportStackLinking = {
  screens: {
    Support: '/support',
  },
}

const SupportStack = createStackNavigator<SupportStackParamList>()

export function Support() {
  const { t } = useTranslation()
  const screenOptions = useScreenOptions()

  return (
    <SupportStack.Navigator screenOptions={screenOptions}>
      <SupportStack.Screen
        name="Support"
        component={SupportScreen}
        options={() => ({
          headerTitleStyle: styles.headerTitle,
          title: t('screens.support.title'),
          headerTitle: () => <HeaderLogo />,
        })}
      />
    </SupportStack.Navigator>
  )
}

export default Support
